module.exports = __webpack_public_path__ + "static/img/fuhua.2642fe0a.png";